/**
 * Single source of truth for the desktop layout switch. Below
 * DESKTOP_BREAKPOINT the mobile layout renders — tablets included, there
 * is deliberately no third layout — and at or above it pages may switch
 * to their desktop arrangement.
 *
 * Usage (component init only — registers an $effect):
 *   const desktop = useDesktop()
 *   {#if desktop.matches} ... {/if}
 */
export const DESKTOP_BREAKPOINT = 1024

const QUERY = `(min-width: ${DESKTOP_BREAKPOINT}px)`

export function useDesktop(): { readonly matches: boolean } {
  let matches = $state(
    typeof window !== "undefined" && window.matchMedia(QUERY).matches,
  )

  $effect(() => {
    const mql = window.matchMedia(QUERY)
    const update = () => {
      matches = mql.matches
    }
    update()
    mql.addEventListener("change", update)
    return () => mql.removeEventListener("change", update)
  })

  return {
    get matches() {
      return matches
    },
  }
}
